import { fetchUserRepo } from "../../repositories/user/user";
import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "userReducer",
  initialState: {
    loading: null,
    user: null,
    user_error: null,
  },
  reducers: {
    Loading(state, action) {
      return {
        ...state,
        medicalDegreeLoading: true,
      };
    },
    setUserInState(state, action) {
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    },
    tokenError(state, action) {
      return {
        ...state,
        loading: false,
        user: null,
        user_error: action.payload,
      };
    },
  },
});
export const { Loading, setUserInState, tokenError } = userSlice.actions;
export const fetchUser = (params) => {
  return async (dispatch) => {
    dispatch(Loading(false));
    await fetchUserRepo()
      .then((response) => {
        dispatch(setUserInState(response?.data));
      })
      .catch((error) => {
        dispatch(tokenError("User Not Authenticated"));
      });
  };
};

export default userSlice.reducer;
